import React from 'react'
import PreviewRoot from '../../Preview'

export default function Overview({appData}) {
  return (
    <div>Overview

      {JSON.stringify(appData)}
      
    </div>
  )
}
